const API_URL = process.env.REACT_APP_API_URL;

export const LoginService = async (username, password) => {
  try {
    const response = await fetch(`${API_URL}/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, password }),
    });


    if (!response.ok) {
      return {"error": true, "content": null};
    }

    return {"error": false, "content": await response.json()};
  } catch (error) {
    return {"error": true, "content": null};
  }
};
